import { Grid, Select, MenuItem, TextField } from "../../../../components";

const FormFiltroAvancado = ({ valueInput, onChangeInput }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          id="nome"
          name="nome"
          label="Nome"
          fullWidth
          variant="outlined"
          onChange={(event) => onChangeInput(event)}
          value={valueInput("nome")}
        />
      </Grid>
      <Grid item xs={12}>
        <Select
          id="tipoTabela"
          name="tipoTabela"
          value={valueInput("tipoTabela")}
          label="Tipo Tabela"
          onChange={(event) => onChangeInput(event)}
          fullWidth
          required
        >
          <MenuItem value={"POR_PRODUTO"}>Por Produto</MenuItem>
          <MenuItem value={"TODOS_PRODUTOS"}>Todos Produtos</MenuItem>
        </Select>
      </Grid>
    </Grid>
  );
};

export default FormFiltroAvancado;
